import { z } from 'zod';

export const createLocationSchema = z.object({
  city: z.string().trim().min(1).max(255),
  address: z.string().trim().min(1).max(255),
  defaultCapacity: z.coerce.number().int().positive(),
});

export type CreateLocationInput = z.infer<typeof createLocationSchema>;
